export class StringUtils {
  static meterSquareFormater(nbr: number): string {
    return `${nbr}m²`;
  }

  static getFirstPartOfUUID(uuid: string): string {
    return uuid.split('-')[0];
  }
}
